import { render, staticRenderFns } from "./MyCFFiles.vue?vue&type=template&id=51384c0b&"
import script from "./MyCFFiles.vue?vue&type=script&lang=ts&"
export * from "./MyCFFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports